export default __webpack_public_path__ + "static/media/ge-ab.760d7485.svg";